import React from 'react'
import './workcard.css'

function WorkCard({item}) {
    return (
        <div className='work-card'>
            <img src={item.companyLogo} className='work-logo'/>

            <div className='work-info'>
                <label className='bold-desc'><a href={item.link} target="_blank"> {item.company}</a></label>
                <label className='company-name'>{item.designation}</label>

                <div className='work-dates'>
                    <label>{item.dateJoining}</label> - <label>{item.dateEnd}</label>
                </div>
                
                <div className='work-desc'>
                    <p>{item.work}</p>
                </div>
            </div>           
        </div>
    )
}

export default WorkCard
